import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import numeral from "numeral"
import Switch from "react-switch"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import Modal from "react-responsive-modal"

//! The table and the summary numbers at the top may not match.  It's net vs actual.  The table is actual, whereas the summary is net - gross - cancels = summary.  Table is actual, so it just skips sales between X and Y with a cancel date.

class Sales extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sorted: [],
			net: true,
			averagesAll: true, // for the average/median boxes, whether or not to be all sales or just sales without lot premium.  true is ALL sales, false is only sales without a premium
			sbsdsorted: [],
			input: [],
			columns: [
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "sectionName",
					filterMethod: (f, r) => helpers.tableText(f, r, "sectionName"),
				},
				{
					Header: "Block",
					accessor: "block",
				},
				{
					Header: "Lot",
					accessor: "lot",
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Contract Price",
					accessor: "price",
					Cell: (props) => numeral(props.value).format("$0,0"),
				},
				{
					Header: "Sq. Ft.",
					accessor: "sqft",
					Cell: (props) => numeral(props.value).format("0,0"),
				},
				{
					Header: "Sale Type",
					accessor: "sale_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_type"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Closed Date",
					accessor: "closing_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closing Price",
					accessor: "closing_price",
					Cell: (props) => {
						if (!props.value) return ""
						return numeral(props.value).format("$0,0")
					},
				},
				{
					Header: "Cancel Date",
					accessor: "cancel_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Buyer First",
					accessor: "primary_first",
					filterMethod: (f, r) => helpers.tableText(f, r, "primary_first"),
				},
				{
					Header: "Buyer Last",
					accessor: "primary_last",
					filterMethod: (f, r) => helpers.tableText(f, r, "primary_last"),
				},
				{
					Header: "Co First",
					accessor: "co_first",
					filterMethod: (f, r) => helpers.tableText(f, r, "co_first"),
				},
				{
					Header: "Co Last",
					accessor: "co_last",
					filterMethod: (f, r) => helpers.tableText(f, r, "co_last"),
				},
				{
					Header: "Price per Sqft",
					accessor: "ppsqft",
					filterMethod: (f, r) => helpers.tableText(f, r, "ppsqft"),
				},
				{
					Header: "Realtor",
					accessor: "realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Welcome Host",
					accessor: "host",
					filterMethod: (f, r) => helpers.tableText(f, r, "host"),
				},
				{
					Header: "Input Date",
					accessor: "addedDate",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
			],
			sbsdColumns: [
				{
					Header: "Year",
					accessor: "year",
				},
				{
					Header: "Month",
					accessor: "month",
					filterMethod: (f, r) => helpers.tableText(f, r, "month"),
				},
				{
					Header: "Gross",
					accessor: "gross",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["gross"]) {
								total += v["gross"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Cancels",
					accessor: "busts",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["busts"]) {
								total += v["busts"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Net Sales",
					accessor: "net",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["net"]) {
								total += v["net"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Starts",
					accessor: "starts",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["starts"]) {
								total += v["starts"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Closed",
					accessor: "closed",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["closed"]) {
								total += v["closed"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Gross Spec Sale",
					accessor: "gross_spec",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["gross_spec"]) {
								total += v["gross_spec"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Gross Dirt Sale",
					accessor: "gross_dirt",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["gross_dirt"]) {
								total += v["gross_dirt"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
			],
			inputColumns: [
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "sectionName",
					filterMethod: (f, r) => helpers.tableText(f, r, "sectionName"),
				},
				{
					Header: "Block",
					accessor: "block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Lot",
					accessor: "lot",
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Contract Price",
					accessor: "price",
					Cell: (props) => numeral(props.value).format("$0,0"),
				},
				{
					Header: "Sq. Ft.",
					accessor: "sqft",
					Cell: (props) => numeral(props.value).format("0,0"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Closed Date",
					accessor: "closing_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Input Date",
					accessor: "addedDate",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Days Difference",
					accessor: "difference",
				},
			],
			upcomingClosings: [
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "sectionName",
					filterMethod: (f, r) => helpers.tableText(f, r, "sectionName"),
				},
				{
					Header: "Block",
					accessor: "block",
				},
				{
					Header: "Lot",
					accessor: "lot",
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Contract Price",
					accessor: "price",
					Cell: (props) => numeral(props.value).format("$0,0"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Estimated Closing",
					accessor: "estimated_closing",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Buyer Last",
					accessor: "primary_last",
					filterMethod: (f, r) => helpers.tableText(f, r, "primary_last"),
				},
				{
					Header: "Primary Email",
					accessor: "primary_email",
					filterMethod: (f, r) => helpers.tableText(f, r, "primary_email"),
				},
				{
					Header: "Realtor",
					accessor: "realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
			],
			prospectJourney: [
				{
					Header: "Buyer",
					accessor: "buyer",
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer"),
				},
				{
					Header: "Email",
					accessor: "email",
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Sale Date",
					accessor: "sale_date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Path",
					accessor: "path",
				},
			],
		}
	}

	buildTable = () => {
		var ret = []
		for (let r of this.props.payload.sales.current) {
			if (!this.props.activeProperties.includes(r.property)) {
				continue
			}
			if (this.state.net) {
				if (r.transfer_date) {
					console.log(r)
				}
				if (r.bustout_date || r.cancel_date || r.transfer_date) {
					continue
				}
			}
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let host
			// Check the primary buyer email for host first
			if (r.host) host = _.find(this.props.payload.public.info_center_users, { id: r.host })
			if (!host) {
				// if no host so far, check the co-buyer email
				if (r.traffic_co_host)
					host = _.find(this.props.payload.public.info_center_users, { id: r.traffic_co_host })
			}
			let sale_type = helpers.isDirtOrSpec(r.sale_date, r.start_date)

			// match email to traffic, see if host
			let ppsqft = r.price && r.sqft ? numeral(r.price / r.sqft).format("$0,0") : ""
			v.sale_id = r.id
			v.sale_type = sale_type
			v.subdivision = r.subdivisionName
			v.neighborhood = r.neighborhoodName
			v.lot_type = r.lotTypeName
			v.builder = builder
			v.sectionName = r.sectionName
			v.block = r.block
			v.lot = r.lot
			v.address = r.address
			v.salesperson = salesperson
			v.primary_last = r.primary_last
			v.primary_first = r.primary_first
			v.primary_email = r.primary_email
			v.buyer_phone = r.buyer_phone
			v.buyer_address = r.buyer_address
			v.buyer_city = r.buyer_city
			v.buyer_state = r.buyer_state
			v.buyer_zip = r.buyer_zip
			v.co_first = r.co_first
			v.co_last = r.co_last
			v.price = r.price
			v.closing_price = r.closing_price
			v.sqft = r.sqft
			v.realtor = r.realtor_name
			v.contract_date = r.sale_date ? r.sale_date : ""
			v.closing_date = r.closing_date
			v.cancel_date = r.bustout_date
			v.addedDate = r.addedDate
			v.ppsqft = ppsqft
			v.host = host ? `${host.first} ${host.last}` : ""

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	buildInputTable = () => {
		var ret = []

		for (let r of this.props.payload.exec.sales) {
			if (!this.props.activeProperties.includes(r.property)) {
				continue
			}
			if (this.state.net) {
				if (r.bustout_date || r.cancel_date) {
					continue
				}
			}
			if (r.addedDate < this.props.currentDates.startStamp || r.addedDate > this.props.currentDates.endStamp) {
				continue
			}
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let addedDate = moment.unix(r.addedDate)
			let saleDate = moment.unix(r.sale_date)
			v.subdivision = r.subdivisionName
			v.neighborhood = r.neighborhoodName
			v.lot_type = r.lotTypeName
			v.builder = builder
			v.sectionName = r.sectionName
			v.block = r.block
			v.lot = r.lot
			v.address = r.address
			v.salesperson = salesperson
			v.price = r.price
			v.sqft = r.sqft
			v.contract_date = r.sale_date ? r.sale_date : ""
			v.closing_date = r.closing_date
			v.cancel_date = r.bustout_date
			v.addedDate = r.addedDate
			v.difference = addedDate.diff(saleDate, "days")
			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()
		//console.log(ret)

		return ret
	}

	buildTotalSales = () => {
		let builders = {}
		for (let r of this.props.payload.sales.current) {
			if (!r.builder) {
				continue
			}
			let bid = r.builder.toString()
			if (!_.has(builders, bid)) {
				builders[bid] = 0
			}
			builders[bid]++
		}
		if (this.state.net) {
			for (let r of this.props.payload.bustouts.current) {
				if (!r.builder) {
					continue
				}
				let bid = r.builder.toString()
				if (!_.has(builders, bid)) {
					builders[bid] = 0
				}
				builders[bid]--
			}
		}
		return _.map(builders, (v, k) => {
			let bid = parseInt(k)
			let builder = _.find(this.props.payload.public.builders, { id: bid })
			if (!builder) {
				return
			}
			return (
				<li className="statBreakout__item" key={k}>
					<div>
						<div className="statBreakout__stat">{v}</div>
						<div className="statBreakout__info">{builder.name}</div>
					</div>
				</li>
			)
		})
	}

	buildMedians = () => {
		try {
			let sales = _.cloneDeep(this.props.payload.sales.current)
			let s = []

			_.forEach(sales, (v) => {
				if (this.state.net && (v.bustout_date || v.cancel_date || v.transfer_date)) {
					return
				}
				if (this.state.averagesAll === false) {
					let premium = parseFloat(v.premium) || 0
					if (premium && typeof premium === "number") {
						v.price = v.price - premium
					}
				}
				s.push(v)
			})
			let medianSalesPrice = helpers.median(s, "price")
			let medianSqft = helpers.median(s, "sqft")
			return {
				medianSalesPrice: numeral(medianSalesPrice).format("$0,0"),
				mediansSqft: numeral(medianSqft).format("0,0"),
				mediansPPSQFT: numeral(medianSalesPrice / medianSqft).format("$0,0"),
			}
		} catch (e) {
			console.log(e)
		}
	}

	buildAverages = () => {
		//? This may be considered actual and not net
		//! If you see this ppsqft number different, check that the calcuation is including sales with sqft.  Sometimes sales come in without sqft and it'll throw the averages off.
		try {
			if (this.props.payload.sales.current.length > 0) {
				let sales = []
				let salesSqFt = [] // remove sales without sqft
				for (let v of this.props.payload.sales.current) {
					let premium = parseFloat(v.premium) || 0
					let price = v.price
					if (this.state.net && (v.bustout_date || v.cancel_date || v.transfer_date)) {
						continue
					}
					if (this.state.averagesAll === false && premium && typeof premium === "number") {
						// remove the premium from the sales price per caldwell
						//v.price = v.price - premium
						price = v.price - premium
					}
					v = { ...v, price }
					if (v.price && v.sqft) {
						salesSqFt.push(v)
					}
					if (v.price) {
						sales.push(v)
					}
				}
				let averageSalesPrice = 0
				let averageSqft = 0
				let averagePpsqft = 0

				let anum = Math.round(_.sumBy(sales, "price") / sales.length) // all sales regardless of square footage
				let sqftPrice = Math.round(_.sumBy(salesSqFt, "price") / salesSqFt.length) // average price on sales with square footage
				let snum = Math.round(_.sumBy(salesSqFt, "sqft") / salesSqFt.length)
				if (!anum) anum = 0
				if (!snum) snum = 0
				averageSalesPrice = `$` + anum.toLocaleString()
				averageSqft = snum.toLocaleString()
				if (averageSalesPrice && averageSqft && sqftPrice && snum) {
					averagePpsqft = `$` + Math.round(sqftPrice / snum)
				} else averagePpsqft = "$0"
				return {
					averageSalesPrice,
					averageSqft,
					averagePpsqft,
				}
			} else {
				return {
					averageSalesPrice: 0,
					averageSqft: 0,
					averagePpsqft: 0,
				}
			}
		} catch (e) {
			console.log(e)
		}
	}

	buildUpcomingClosings = () => {
		var ret = []
		let sales = _.filter(
			this.props.payload.exec.sales,
			(r) => r.sale_date && !r.bustout_date && !r.closing_date && !r.transfer_date
		)
		for (let r of sales) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			v.sale_id = r.id
			v.subdivision = r.subdivisionName
			v.neighborhood = r.neighborhoodName
			v.lot_type = r.lotTypeName
			v.builder = builder
			v.sectionName = r.sectionName
			v.block = r.block
			v.lot = r.lot
			v.address = r.address
			v.salesperson = salesperson
			v.primary_email = r.primary_email
			v.primary_last = r.primary_last
			v.buyer_phone = r.buyer_phone
			v.price = r.price
			v.realtor = r.realtor_name
			v.contract_date = r.sale_date ? r.sale_date : ""
			v.estimated_closing = r.estimated_closing
			v.addedDate = r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "estimated_closing")

		return ret
	}

	buildSalesBustsSpecDirt = () => {
		let model = {
			gross: 0,
			busts: 0,
			net: 0,
			starts: 0,
			closed: 0,
			gross_spec: 0,
			gross_dirt: 0,
			month_no: 0,
			year_no: 0,
		}
		var ret = {}

		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			let month = moment.unix(v.sale_date).format("MMMM")
			let path = `${year}.${month}`
			if (!_.has(ret, path)) {
				_.set(ret, path, _.clone(model))
			}
			ret[year][month].year_no = moment.unix(v.sale_date).year()
			ret[year][month].month_no = moment.unix(v.sale_date).month() + 1
			ret[year][month].gross++
			if (v.start_date && v.start_date <= v.sale_date) {
				ret[year][month].gross_spec++
			} else {
				ret[year][month].gross_dirt++
			}
		})

		_.forEach(this.props.payload.bustouts.current, (v) => {
			let year = moment.unix(v.bustout_date).format("YYYY")
			let month = moment.unix(v.bustout_date).format("MMMM")
			let path = `${year}.${month}`
			if (!_.has(ret, path)) {
				_.set(ret, path, _.clone(model))
			}
			ret[year][month].busts++
			ret[year][month].month_no = moment.unix(v.bustout_date).month() + 1
			ret[year][month].year_no = moment.unix(v.bustout_date).year()
		})

		_.forEach(this.props.payload.closings.current, (v) => {
			let year = moment.unix(v.closing_date).format("YYYY")
			let month = moment.unix(v.closing_date).format("MMMM")
			let path = `${year}.${month}`
			if (!_.has(ret, path)) {
				_.set(ret, path, _.clone(model))
			}
			ret[year][month].closed++
			ret[year][month].month_no = moment.unix(v.closing_date).month() + 1
			ret[year][month].year_no = moment.unix(v.closing_date).year()
		})
		_.forEach(ret, (obj, year) => {
			_.forEach(obj, (v, month) => {
				v.net = v.gross - v.busts
			})
		})

		_.forEach(this.props.payload.exec.lots, (v) => {
			// starts
			if (v.start_date >= this.props.currentDates.startStamp && v.start_date < this.props.currentDates.endStamp) {
				let year = moment.unix(v.start_date).format("YYYY")
				let month = moment.unix(v.start_date).format("MMMM")
				let path = `${year}.${month}`
				if (!_.has(ret, path)) {
					_.set(ret, path, _.clone(model))
				}
				ret[year][month].starts++
				ret[year][month].month_no = moment.unix(v.start_date).month() + 1
				ret[year][month].year_no = moment.unix(v.start_date).year()
			}
		})
		let f = []
		_.forEach(ret, (row, year) => {
			_.forEach(row, (v, month) => {
				f.push({
					year: year,
					month: month,
					year_no: v.year_no,
					month_no: v.month_no,
					gross: v.gross,
					busts: v.busts,
					net: v.net,
					starts: v.starts,
					closed: v.closed,
					gross_spec: v.gross_spec,
					gross_dirt: v.gross_dirt,
				})
			})
		})
		f = _.sortBy(f, ["year_no", "month_no"])
		f = _.reverse(f)
		return f
	}

	buildProspectJourney = () => {
		let ret = []
		_.forEach(this.props.payload.sales.current, (v) => {
			if (
				(Array.isArray(v.traffic_entries) && v.traffic_entries.length > 0) ||
				(Array.isArray(v.leads) && v.leads.length > 0)
			) {
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				let section = _.find(this.props.payload.public.sections, { id: v.section_id })
				let salesperson = _.find(this.props.payload.users, { id: v.salesperson })
				ret.push({
					buyer: `${v.primary_first} ${v.primary_last}`,
					address: v.address,
					builder: builder ? builder.name : "",
					section: section ? section.name : "",
					email: v.primary_email,
					salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
					prospect: `${v.primary_first} ${v.primary_last}`,
					sale_date: v.sale_date,
					closing_date: v.closing_date || null,
					path: (
						<div
							className="btn btn--square text-xs p-1"
							onClick={() => {
								this.setState({ journeyModal: true, journey: v })
							}}>
							View Path
						</div>
					),
				})
			}
		})

		return ret
	}

	buyerJourney = () => {
		const TimelineItem = ({ date, content, isEven }) => (
			<div className="flex items-center mb-8 text-sm">
				<div className="w-1/2 flex justify-end pr-4">
					{isEven ? (
						<span className="text-right">{date}</span>
					) : (
						<span className="text-right font-bold">{content}</span>
					)}
				</div>
				<div className="w-3 h-3 bg-green-600 rounded-full z-10 flex-shrink-0"></div>
				<div className="w-1/2 pl-4">
					{isEven ? <span className="font-bold">{content}</span> : <span className="">{date}</span>}
				</div>
			</div>
		)

		const VerticalTimeline = ({ events }) => {
			return (
				<div className="relative max-w-3xl mx-auto">
					<div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-green-500"></div>
					{events.map((event, index) => (
						<TimelineItem key={index} date={event.date} content={event.content} isEven={index % 2 === 0} />
					))}
				</div>
			)
		}
		let events = []
		let sorted = _.sortBy(this.state.journey?.traffic_entries, "traffic_date")
		_.forEach(sorted, (entry) => {
			let builder = _.find(this.props.payload.public.builders, { id: entry.builder })
			let builderName = builder ? builder.name : "Welcome Center"
			let model = ``
			if (entry.lot_id) {
				let lot = _.find(this.props.payload.exec.lots, { id: entry.lot_id })
				if (lot?.address) model = ` at model: ${lot?.address}`
			}
			events.push({
				date: moment.unix(entry.traffic_date).format("MM/DD/YY"),
				dateStamp: entry.traffic_date,
				content: `Visited: ${builderName}${model}`,
			})
		})
		sorted = _.sortBy(this.state.journey?.leads, "addedDate")
		_.forEach(sorted, (entry) => {
			if (entry.property !== this.state.journey?.property) return
			let sps = []
			_.forEach(entry.emails_sent, (s) => {
				let sp = _.find(this.props.payload.users, { id: s })
				if (sp) {
					sps.push(`${sp.first} ${sp.last}`)
				}
			})
			let builder = _.find(this.props.payload.public.builders, { id: entry.builder })
			let builderName = builder?.name || ""
			let interest = ``
			if (entry.lot_id) {
				let lot = _.find(this.props.payload.exec.lots, { id: entry.lot_id })
				interest = ` for Address: ${lot.address}`
			} else if (entry.floorplan) {
				let floorplan = _.find(this.props.payload.public.floorplans, { id: entry.floorplan })
				interest = ` for Floorplan: ${floorplan.name}`
			}
			events.push({
				date: moment.unix(entry.addedDate).format("MM/DD/YY"),
				dateStamp: entry.addedDate,
				content: `Web Lead: ${builderName}${interest}.  Emails sent to: ${sps.join(", ")} at ${moment
					.unix(entry.addedDate)
					.format("hh:mm A")}`,
			})
		})
		events = _.sortBy(events, "dateStamp")
		// Add sale/closing
		let builder = _.find(this.props.payload.public.builders, { id: this.state.journey?.builder })
		events.push({
			date: moment.unix(this.state.journey?.sale_date).format("MM/DD/YY"),
			content: `Bought ${this.state.journey?.address} with ${builder?.name} for ${numeral(
				this.state.journey?.price
			).format("$0,0")}`,
		})
		if (this.state.journey?.closing_date) {
			events.push({
				date: moment.unix(this.state.journey?.closing_date).format("MM/DD/YY"),
				content: `Closed for ${numeral(this.state.journey?.closing_price).format("$0,0")}`,
			})
		}

		return (
			<>
				<h2>
					Buyer Journey for {this.state.journey?.primary_first} {this.state.journey?.primary_last}
				</h2>
				<VerticalTimeline events={events} />
			</>
		)
	}

	total = () => {
		let c = 0
		for (let r of this.props.payload.sales.current) {
			c++
		}
		if (this.state.net) {
			for (let r of this.props.payload.bustouts.current) {
				c--
			}
		}

		return numeral(c).format("0,0")
	}

	toggle = () => {
		this.setState({ net: !this.state.net })
	}

	render() {
		let averages = this.buildAverages()
		let medians = this.buildMedians()

		if (this.props.payloadStatus) {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Sales Overview" />
						<div
							className="switch content"
							style={{ marginBottom: 15 }}
							onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() => this.toggle()}
								checked={this.state.net}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
							/>
							<p>Showing {this.state.net ? "Net" : "Gross"}</p>
						</div>
						<div className="statBreakout">
							<div className="statBreakout__group">
								<h3 className="statBreakout__title">
									{this.total()} {this.state.net ? "Net" : "Gross"} Sales{" "}
									<span>
										for {this.props.currentDates.startText} - {this.props.currentDates.endText}
									</span>
								</h3>
								<ul className="statBreakout__list">{this.buildTotalSales()}</ul>
							</div>
						</div>
						<div className="quickStats quickStats--light">
							<div className="switch content text-xs flex justify-end w-[90%] mx-auto">
								<div className="flex items-center">
									<p>Showing {this.state.averagesAll ? "All Sales" : "Sales Without Premium"}</p>
									<Switch
										onChange={() => {
											this.setState({ averagesAll: !this.state.averagesAll })
										}}
										checked={this.state.averagesAll}
										checkedIcon={false}
										uncheckedIcon={false}
										key={"switch"}
										id={"switch"}
										width={30}
										height={15}
									/>
								</div>
							</div>
							<ul className="quickStats__list">
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{averages.averageSalesPrice}</div>
										<div className="quickStats__type">Average Sale Price</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{averages.averageSqft}</div>
										<div className="quickStats__type">Average Square Feet</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{averages.averagePpsqft}</div>
										<div className="quickStats__type">Average PPSQFT</div>
									</div>
								</li>
							</ul>
							<ul className="quickStats__list">
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{medians.medianSalesPrice}</div>
										<div className="quickStats__type">Median Sale Price</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{medians.mediansSqft}</div>
										<div className="quickStats__type">Median Square Feet</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{medians.mediansPPSQFT}</div>
										<div className="quickStats__type">Median PPSQFT</div>
									</div>
								</li>
							</ul>
						</div>
						<div className="recentActivity content">
							<h2>
								Actual Sales for {this.props.currentDates.startText} - {this.props.currentDates.endText}
							</h2>
							<p className="text-sm mt-2">
								Please note these are actual sales, not gross. If a buyer bought and cancelled within
								this time frame, it will not show.
							</p>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="salesOverview__allSales"
								title="Sales"
								classNames={"small"}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h2>Sales, Cancels, Spec &amp; Dirt by Month</h2>
							<FullTable
								data={this.buildSalesBustsSpecDirt()}
								columns={this.state.sbsdColumns}
								name="salesOverview__sbsd"
								title="Sales"
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h2>
								Sales Input for {this.props.currentDates.startText} - {this.props.currentDates.endText}
							</h2>
							<FullTable
								data={this.buildInputTable()}
								columns={this.state.inputColumns}
								name="salesOverview__input"
								title="SalesInput"
								classNames={"small"}
							/>
							<h2>Buyer Journey</h2>
							<FullTable
								classNames={"small"}
								data={this.buildProspectJourney()}
								columns={this.state.prospectJourney}
								name="closings__prospectJourney"
								title="Prospect Journey"
							/>
							<Modal
								classNames={{ modal: "modalForm" }}
								open={this.state.journeyModal}
								onClose={() => this.setState({ journeyModal: false })}
								center>
								{this.buyerJourney()}
							</Modal>
							<h2>Upcoming Closings</h2>
							<FullTable
								data={this.buildUpcomingClosings()}
								columns={this.state.upcomingClosings}
								name="salesOverview__input"
								title="SalesInput"
								classNames={"small"}
								defaultSorted={[
									{
										id: "estimated_closing",
										asc: true,
									},
								]}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Sales)
